import { render, staticRenderFns } from "./editContractType.vue?vue&type=template&id=6320e020&scoped=true"
import script from "./editContractType.vue?vue&type=script&lang=js"
export * from "./editContractType.vue?vue&type=script&lang=js"
import style0 from "./editContractType.vue?vue&type=style&index=0&id=6320e020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320e020",
  null
  
)

export default component.exports